import { LOGO_URL } from "@/data/quiz";

export default function SiteHeader({ onStart }) {
  return (
    <header
      className="sticky top-0 z-50 backdrop-blur-md bg-[#faf8f5]/90 border-b border-[#e2ded7]"
      data-testid="site-header"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <a href="/" className="flex items-center gap-3" data-testid="header-logo-link">
          <img src={LOGO_URL} alt="The Weave" className="h-8 w-auto" />
          <span className="hidden sm:flex items-center gap-1.5 text-xs text-[#5a686b]">
            <span className="uppercase tracking-widest font-semibold">Founder Academy</span>
            <span className="text-[#c7cfd0]" aria-hidden="true">—</span>
            <span className="italic">Experience, rewoven</span>
          </span>
        </a>
        <div className="flex items-center gap-2 sm:gap-4">
          {onStart && (
            <button
              onClick={onStart}
              data-testid="header-start-button"
              className="text-sm font-medium text-white bg-[#4aa0a4] hover:bg-[#3b868a] transition-colors px-4 py-2 rounded-full"
            >
              Take the quiz
            </button>
          )}
          <a
            href="/admin/login"
            data-testid="header-admin-link"
            className="text-sm font-medium text-[#5a686b] hover:text-[#1e292b] transition-colors"
          >
            Admin
          </a>
        </div>
      </div>
    </header>
  );
}
